<template>
  <div>
    <div style="margin-top: 50px;margin-left: 10%;margin-right: 10%;margin-bottom: 50px;">
      <Row style="margin-top: 20px">
        <Col span="4" style="text-align: right">
          <span style="font-size: 20px;flood-color: #ed4014">分类：</span>
        </Col>
        <Col span="20" style="text-align: left">
        <RadioGroup v-model="publish" type="button" @on-change="radioPublish(publish)">
          <Radio label="全部"></Radio>
          <Radio label="服饰"></Radio>
          <Radio label="数码"></Radio>
          <Radio label="配件配饰"></Radio>
          <Radio label="家具"></Radio>
        </RadioGroup>
        </Col>
      </Row>
      <Row style="margin-top: 20px">
        <Col span="4" style="text-align: right">
        <span style="font-size: 20px;flood-color: #ed4014">价格：</span>
        </Col>
        <Col span="20" style="text-align: left">
        <RadioGroup>
          <Radio label="0-100"></Radio>
          <Radio label="100-200"></Radio>
          <Radio label="200-500"></Radio>
          <Radio label="500-1000"></Radio>
          <Radio label="1000+"></Radio>
        </RadioGroup>
        </Col>
      </Row>
      <Row style="margin-top: 20px">
        <Col span="4" style="text-align: right">
        <span style="font-size: 20px;flood-color: #ed4014">上架时间：</span>
        </Col>
        <Col span="20" style="text-align: left">
        <DatePicker type="daterange" placement="bottom-end" placeholder="Select date" style="width: 200px"></DatePicker>
        </Col>
      </Row>
      <Row align="middle" style="margin-top: 100px;">
        <Col span="8">
          <div style="text-align:center">
            <a @click="changeCommodity01"><img style="width: 300px;height: 300px;" src="../assets/commodity/01/00.jpg"/>
            </a>
          </div>
        </Col>
        <Col span="8">
          <div style="text-align:center">
            <a @click="changeCommodity02"><img style="width: 300px;height: 300px;" src="../assets/commodity/02/00.jpg"/></a>
          </div>
        </Col>
        <Col span="8">
          <div style="text-align:center">
            <a @click="changeCommodity03"><img style="width: 300px;height: 300px;" src="../assets/commodity/03/00.jpg"/></a>
          </div>
        </Col>
      </Row>
      <Row>
        <Col span="8">
        <a @click="changeCommodity01" style="font-family: 楷体;font-size: 20px;font-weight: bold">风阻液阻划水机￥1599</a>
        </Col>
        <Col span="8">
        <a @click="changeCommodity02" style="font-family: 楷体;font-size: 20px;font-weight: bold">腹肌贴￥518</a>
        </Col>
        <Col span="8">
        <a @click="changeCommodity03" style="font-family: 楷体;font-size: 20px;font-weight: bold">自动回弹健腹轮￥418</a>
        </Col>
      </Row>
      <Row align="middle" style="margin-top: 100px;">
        <Col span="8">
        <div style="text-align:center">
          <a @click="changeCommodity04"><img style="width: 300px;height: 300px;" src="../assets/commodity/04/00.jpg"/>
          </a>
        </div>
        </Col>
        <Col span="8">
        <div style="text-align:center">
          <a @click="changeCommodity05"><img style="width: 300px;height: 300px;" src="../assets/commodity/05/00.jpg"/></a>
        </div>
        </Col>
        <Col span="8">
        <div style="text-align:center">
          <a @click="changeCommodity06"><img style="width: 300px;height: 300px;" src="../assets/commodity/06/00.jpg"/></a>
        </div>
        </Col>
      </Row>
      <Row>
        <Col span="8">
        <a @click="changeCommodity04" style="font-family: 楷体;font-size: 20px;font-weight: bold">手表￥428</a>
        </Col>
        <Col span="8">
        <a @click="changeCommodity05" style="font-family: 楷体;font-size: 20px;font-weight: bold">休闲百搭网鞋刀锋鞋运动鞋￥248</a>
        </Col>
        <Col span="8">
        <a @click="changeCommodity06" style="font-family: 楷体;font-size: 20px;font-weight: bold">真皮时尚休闲板鞋￥268</a>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'HelloWorld',
    data () {
      return {
        publish:"全部",
      }
    },
    mounted () {

    },
    methods:{
      changeCommodity01(){
        this.$router.push({path:'/commodity01'})
      },
      changeCommodity02(){
        this.$router.push({path:'/commodity02'})
      },
      changeCommodity03(){
        this.$router.push({path:'/commodity03'})
      },
      changeCommodity04(){
        this.$router.push({path:'/commodity04'})
      },
      changeCommodity05(){
        this.$router.push({path:'/commodity05'})
      },
      changeCommodity06(){
        this.$router.push({path:'/commodity06'})
      },
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  a:link{
    color:black;
  }
  a:hover{
    color:red;
  }
  a:active{
    color:darkred;
  }
  .image-into{
    padding:10px;
  }
  .image-out{
    padding:0px;
  }
  .demo-split{
    height: 200px;
    border: 1px solid #dcdee2;
  }
  .demo-split-pane{
    padding: 10px;
  }
  .demo-split-pane.no-padding{
    height: 200px;
    padding: 0;
  }

  .demo-upload-list{
    display: inline-block;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0,0,0,.2);
    margin-right: 4px;
  }
  .demo-upload-list img{
    width: 100%;
    height: 100%;
  }
  .demo-upload-list-cover{
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
  }
  .demo-upload-list:hover .demo-upload-list-cover{
    display: block;
  }
  .demo-upload-list-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
  .govm-ico {
    display: inline-block;
    width: 18px;
    height: 20px;
    /*background: url("../../assets/images/home_pic.png") no-repeat -87px -31px;*/
    position: relative;
    top: 4px;
    right: 6px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Commodity.vue